/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    testimonials: {
        menu: {
            index: 'Testimonials',
            create: 'New testimonial',
            list: 'Testimonials'
        },
        table_titles: {
            id: 'ID',
            user: 'User\'s name',
            link: 'Testimonial\'s link',
            alias: 'Alias',
            comment: 'Comment',
            pinned: 'Pinned',
            show_photo: 'Show photo',
            published_at: 'Published date',
            setting: 'Edit / Delete',
        },
        no: 'No',
        yes: 'Yes',
        edit: 'Edit a testimonial'
    }
}
